/**
 * Whether two renderings of something the agent said are the same sentence.
 * A streamed copy and the stored answer can differ in line breaks and
 * spacing, never in words.
 */
export function sameSpokenText(a: string, b: string): boolean {
  return a.replace(/\s+/g, " ").trim() === b.replace(/\s+/g, " ").trim();
}
